module.exports = "mutation ShareContact($contact: ID!, $username: String!) {\n  shareContact(contact: $contact, username: $username) {\n    shared\n  }\n}\n"